import {
  BrandMoreOnRaise,
  BrandRating,
  BrandRedemptionDetails,
  BrandTrackAndSell,
  ReferralBanner
} from "components/UI/molecules";
import { Recommended } from "..";
import { useAppContext } from "context/app-context";

export const MobileBrandDetails = ({ brandDetails, brandTerms }) => {
  const {
    productSourceId,
    cardTypeDescription,
    name,
    isApple,
    path,
    rating,
    ratingCount,
    ratingUpdatedAt,
    legacyBrandId
  } = brandDetails;
  const {
    sessionInfo: { isLoggedIn }
  } = useAppContext();

  return (
    <>
      <div className="mobile-brand-details" data-testid="mobile-brand-details">
        <BrandRedemptionDetails
          terms={brandTerms}
          card={cardTypeDescription}
          name={name}
          isApple={isApple}
        />
        <BrandTrackAndSell
          name={name}
          productSourceId={productSourceId}
          isLoggedIn={isLoggedIn}
        />
        <BrandMoreOnRaise isLoggedIn={false} name={name} path={path} />
        <BrandRating
          rating={{
            value: rating,
            count: ratingCount,
            updatedAt: ratingUpdatedAt
          }}
        />
        <Recommended legacyBrandId={legacyBrandId} />
      </div>
      <ReferralBanner />
    </>
  );
};
